module.exports = __webpack_public_path__ + "img/add-image.7a9ce37e.png";